import { render } from "./AppPostImage.html?vue&type=template&id=1e8552a7"
import script from "./AppPostImage.js?vue&type=script&lang=js"
export * from "./AppPostImage.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__